import React from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { OFAKIM_FORM_NAME } from 'apps/auth/constants/formName';

const KycOfakimDocNumberModal = (props) => {
    return (
        <ModalComponent onCloseIconClick={props.onCloseClick}>
            <HeaderPanel title={props.title} />
            <Form
                id="ofakim_form_id"
                onSubmitHandler={props.onSubmitHandler}
                action={props.action}
                getCanonicalPath={true}
                checkNotVisibleField={false}
                formName={OFAKIM_FORM_NAME}
            >
                {props.getSecondScreenFields(props.fields).map((f) => {
                    return (
                        <Row indent="adaptive-32-48" key={`fields_${f.name}`}>
                            <InputAutoDetect field={f} key={f.name} formName={OFAKIM_FORM_NAME} />
                        </Row>
                    );
                })}
                <FixedBottomPanel isRightAligned>
                    <Button type="submit" ref={props.submitRef} caption={props.buttonContinue} disabled={!props.isEnabled(props.fields)} raised={true} />
                </FixedBottomPanel>
            </Form>
        </ModalComponent>
    );
};

export default KycOfakimDocNumberModal;
